import LocalizedStrings from 'react-localization';

let String = new LocalizedStrings({

        en: {
                lessthan:'less than 1 year ' ,
                morethan:'more than 5 years',
                FaceBookSignIn: "Sing in with FaceBook",
                GoogleSignIn: "Sign in with Google",

                // Buttons
                sendbtn: "Send",
                addbtn: "Add",
                editbtn: "Edit",
                deletebtn: "Delete",
                nextBTN: "Next",
                saveBTN: "Save",

                // header
                aboutUs: 'About-us',
                home: 'Home',
                Family: 'Family',
                childern: "Children's",
                animals: 'Pets',
                contactus: 'Contact-us',
                Arlang: 'Arabic',
                Enlang: 'English',
                privacyPolicy: 'Privacy policy',
                termsAndConditions: 'Terms and Conditions',
                register: 'Register',

                // Home
                whous: "Who Us",
                showmore: "Show More",
                rays: "Radiation and Investigation",
                lab: "Lab",
                prescription: "Prescription",
                contactUs: "Contact Us",
                username: "Username",
                phonenum: "Phone Number",

                // ContactUs
                downloadapp: "Donwload App Now",

                // Profile
                personId: "ID",
                editprofile: "Edit Profile",
                filesattached: "attached files",
                logout: "Logout",
                prescriptionhistory: "Date of prescription / disclosure",
                doctorname: "Doctor Name",
                medicinename: "medicament name",
                medicinedate: "Date taking medication",
                diagnosis: "Diagnosis",
                analyzesdate: "History of Analyzes",
                labname: "Lab Name",
                raysdate: "History of Radiation and Investigation",
                raystype: "Radiation Type",
                placename: "Place Name",
                deletecard: "Do you want delete  ",
                fortifications: "Fortifications",
                choosecategory: "Choose from this categories",
                internaldiseases: "Internal diseases",
                respiratorysystem: "Respiratory system",
                earnose: "Ear, Nose and Throat",
                AddAnimal: 'Add Animal',
                AddBtn: 'Add',
                upload: 'Upload',
                PersonalInfo: "Personal Information",
                medicineInfo: "Medical Information",
                email: "Email",
                nationalID: "National ID",
                nationalIDImages: "National ID Card  Images",
                medcalCardImages: "Medical Insurnce Card Images if exist",
                male: "Male",
                female: "Female",
                changePassword: "Change Password",
                resetPassword: "Reset Password",
                recentpassword: "currentPassword",
                medicines: "medicines and drugs",
                chronicDiseases: "write chroncis disease name...",
                sensitivityType: "sensitivity Type",
                operationName: "operation Name",
                doctorName: "doctor Name",
                nomediciene: "No Medicen and drugs added yet",
                PersonalInfo: "Personal Information",
                medicineInfo: "Medical Information",
                email: "Email",
                nationalID: "National ID",
                nationalIDImages: "National ID Card  Images",
                medcalCardImages: "Medical Insurnce Card Images if exist",
                male: "Male",
                female: "Female",
                changePassword: "Change Password",
                resetPassword: "Reset Password",
                recentpassword: "currentPassword",
                medicines: "medicines and drugs",
                // Auth
                forgetpassword: "Forget Password ?",
                enterphonenum: "Enter the mobile number with which you registered Before .. to send the code to it",
                entercode: "Enter the code sent on your mobile",
                enterpassword: "Enter the new password",
                newregister: "Don't have Accoutn? New Registeration",
                password: "Password",
                confpassword: "Confirm Password",

                //Lab
                Lab: 'Lab',
                AddPerson: 'Add Person From Family',

                // Children
                addchildren: "Add Person Data from Children",
                addfamily: "Add Person Data from Family",
                addanimal: "Add Animal Data",
                AddChiled: 'Add Children',
                Ray: 'Radiation and Investigation',
                Fortifications: 'Fortifications',
                FortificationsName: 'Fortification Name',
                FortificationsDate: 'Fortification Date',
                FortificationsCardImg: 'Fortifications Card Image',
                profile: 'Profile',
                alert: 'Alert',
                medicineName: 'Medicine Name',
                medicineTime: 'Medicine Time',
                doctorName: 'Doctor Name',
                other: 'Other',
                Diagnosis: 'Write the Diagnosis',
                PrescriptionsCardImg: "Add a prescription picture",
                title: 'Title',
                DiagnosisSideTitle: 'Diagnosis',

                // View Details
                Diagnosisname: "Name of Diagnosis",
                Diagnosishistory: "History of Diagnosis",
                birthcert: "National ID  Photo",
                helthinsu: "Health Insurance Card Photo",
                gender: "Gender",
                animaltype: "Animal Type",
                bloodtype: "Blood Type",
                age: "Age",
                years: "Years",
                PhoneNum: 'Phone Number',
                next: 'Next',
                labs: 'Labs',
                labDate: 'Lab Date',
                SeeMoreImgs: 'See More Images',
                labTitle: 'Lab Report Image',
                labSubTitle: '* May be more than one image',
                EditBtn: 'Edit',
                noLabs: 'there are no labs',
                NoRays: 'There are no radiations',
                Precription: 'Precriptions',
                Diagnose: 'Diagnose',
                specialty: 'Specialty',
                All: 'All',
                diagnoseType: 'Diagnose Type',
                RaysDate: 'Radiation Date',
                RayType: 'Radiation Type',
                Rays: 'Radiation and Investigation',
                fortificationsName: 'Fortifications Name',
                fortificationsDate: 'Fortifications Date',
                Fortifications: 'Fortifications',
                NoFortification: 'There ara no fortifications',
                FortificationsType: 'Fortification Type',
                SelectDate: 'Select Date',
                Placename: 'Place Name',
                RayDate: 'Radiation Date',
                ReportImage: 'Report Images',
                RaysImg: "Images Of Radiation",
                PrescriptionImg: 'Image Of Prescription',
                noExist: 'No Exist',
                PrescriptionDate: 'Prescription Date',
                otherDiagnosis: 'Other Diagnosis',
                Medicine: 'Medicine',
                Edit: 'Edit',
                roshtaTitle: 'Prescription Images',
                roshtaSubTitle: '* May be more than one image',
                ShowMore: 'Show More',
                MedicenTimeTitle: 'Medicines ',
                personName: 'Person Name',
                age: 'Age',
                ageUnit: 'Year',
                type: 'Type',
                Male: 'Male',
                Female: 'Female',
                relationType: 'Relation Type',
                FATHER: 'Father',
                MOTHER: 'Mother',
                SISTER: 'Sister',
                BROTHER: 'Brother',
                healthInsuranceImg: 'Health Insurance Card',
                personalID: 'National ID Image',
                Labs: 'Labs',
                Rays: 'Radiation and Investigation',
                noPrescription: 'No Prescription',
                animalEmpty: "There is no Animals",
                FamilyEmpty: "There is no Family",
                ChildernEmpty: "There is no Children",
                oneYear: "year",
                twoYear: "years",
                moreYear: "years",
                customYear: "years",
                sectionsTitle: 'Choose The Category',
                LabDate: 'Lab Date',
                other: 'Other',
                selectDiagnose: 'Select Diagnose',
                CheckboxError: 'Should at least select one fortifaction',
                errorDate: 'Should enter date of fortifaction',
                ComleteProfile: 'You should complete your profile',
                completemsg: 'Complete Your Profile',
                mailConfirmed: 'Your email is confirmed successfully',
                closeBt: 'Close',
                mailConfirmedFaild: 'Confirm your email failed',
                skip: 'Skip',
                noExist: 'No Exist',
                Am: 'am',
                Pm: 'pm',
                ResendCode: "Resend Code",
                //Notification
                Notification: "Notification",
                Pm: 'pm',
                ResendCode: "Resend Code",
                EditAnimal: 'Edit Animal Information',
                EditDone: "Edit Profile Done",
                EditSon: 'Edit Children',
                birthdayImage: "National ID  Photo",
                healthCardImage: 'Health Insurance Certificate (optional)',
                confirmCodeError: "Please Enter Code",
                ImageError: 'Images is Required *',
                EditFamily: 'Edit Person',
                labReport:"Lab Report Image",
                percipctionReport:"Percipiction Image",
                birthdayImageSon:'Birth Certificates',
                ConditionsError:'Must Accept Conditions and Terms',
                Conditions:'Accept Conditions and Terms',
                specialtySideTitle:'Specialty',
                specialtyType:'Specialty',
                nationalIdErrorString:'National Id is required *'
                
        },
        ar: {
                nationalIdErrorString:'يجب ادخال صورة الرقم القومي',
                specialtyType:'التخصص',
                specialtySideTitle:'التخصص',
                Conditions:'موافق علي الشروط و الاحكام',
                ConditionsError:'يجب الموافقة علي الشروط و الاحكام',
                lessthan:'اقل من سنة ' ,
                morethan:'اكثر من 5 سنين',
                birthdayImageSon:"شهادة الميلاد",
                percipctionReport:"صوره الروشتة",
                labReport:"صور تقارير المعمل",
                EditFamily: 'تعديل بيانات شخص',
                ImageError: 'يجب ادخال الصور *',
                healthCardImage:'صور كارنية التامين الصحي (ان وجد)',
                birthdayImage: 'صور الرقم القومي',
                confirmCodeError: "من فضلك ادخل الكود",
                EditSon: 'تعديل بيانات شخص من الاولاد',
                EditAnimal: 'تعديل بيانات الحيوان',
                Pm: 'مساء',
                EditDone: "تم التعديل بنجاح",
                Pm: 'مساء',
                Am: 'صباحا',
                noExist: 'لا يوجد',
                skip: 'تخطي',
                ResendCode: "اعادة ارسال الكود",
                mailConfirmedFaild: 'تاكيد بريدك الالكتروني فشل',
                closeBt: 'أغلاق',
                mailConfirmed: 'تم تاكيد بريدك الالكتروني',
                completemsg: 'اكمال البيانات',
                ComleteProfile: 'من فضلك قم باستكمال بياناتك',
                errorDate: 'يجب تحديد تاريخ التحصين',
                CheckboxError: 'يجب علي الاقل اختيار تحصين واحد',
                selectDiagnose: 'اختر التشخيص',
                other: 'أخري',
                LabDate: 'تاريح المعمل',
                sectionsTitle: 'اختر من هذه الاقسام',
                oneYear: "سنة",
                customYear: "سنة",
                twoYear: "سنين",
                moreYear: "سنوات",
                ChildernEmpty: "لا يوجد اولاد",
                FamilyEmpty: "لا يوجد اسرة",
                animalEmpty: "لا يوجد حيوانات",
                noPrescription: 'لا توجد روشتات',
                Rays:'الفحوصات و الاشعة',
                Labs: 'المعامل',
                personalID: 'صورة  الرقم القومى',
                healthInsuranceImg: 'صورة كارنية التأمين الصحي',
                SISTER: 'أخت',
                BROTHER: 'أخ',
                MOTHER: 'أم',
                FATHER: 'أب',
                relationType: 'صلة القرابة',
                Female: 'انثي',
                Male: 'ذكر',
                type: 'النوع',
                ageUnit: 'سنه',
                age: 'العمر',
                personName: 'اسم الشخص',
                MedicenTimeTitle: 'الادوية',
                ShowMore: 'رؤية المزيد',
                FaceBookSignIn: "التسجيل من خلال الفيسبوك",
                GoogleSignIn: "التسجيل بواسطه جوجل",
                roshtaSubTitle: 'يمكن ان تكون صورة او اكتر *',
                roshtaTitle: 'صور الروشتة',
                Edit: 'تعديل',
                Medicine: 'الادوية',
                otherDiagnosis: 'تشخيص اخر',
                PrescriptionDate: 'تاريخ الروشتة',
                noExist: 'لا يوجد',
                PrescriptionImg: ' صورة الروشتة',
                RaysImg: 'صور الاشعة',
                ReportImage: 'صور التقرير',
                RayDate: 'تاريخ الاشعة',
                Placename: 'اسم المكان',
                SelectDate: 'اختر التاريخ',
                FortificationsType: 'انواع التحصينات',
                NoFortification: 'لا يوجد تحصينات',
                Fortifications: 'التحصينات',
                fortificationsDate: 'تاريخ التحصين',
                fortificationsName: 'اسم التحصين',
                Rays: 'الفحوصات و الاشعة',
                NoRays: 'لا توجد اشعة',
                RayType: 'نوع الاشعه',
                RaysDate: 'تاريخ الاشعه',
                diagnoseType: 'نوع التشخيص',
                All: 'كل',
                specialty: 'التخصص',
                Diagnose: 'التشخيص',
                Precription: 'الروشتات',
                noLabs: 'لا يوجد معامل',
                EditBtn: 'تعديل',
                labSubTitle: 'يمكن ان تكون صورة او اكتر *',
                labTitle: 'صورة تقرير المعمل ',
                SeeMoreImgs: 'رؤية المزيد من الصور',
                labDate: 'تاريخ التحليل',
                labs: 'المعامل',
                // Buttons
                sendbtn: "ارسال",
                addbtn: "اضافة",
                editbtn: "تعديل",
                deletebtn: "حذف",
                nextBTN: "التالي",
                saveBTN: "حفظ",

                //header
                aboutUs: 'من نحن',
                home: 'الرئيسيه',
                Family: 'الأسرة',
                childern: 'الأولاد',
                animals: 'الحيوانات الأليفة',
                contactus: 'اتصل بنا',
                Arlang: 'عربي',
                Enlang: 'انجليزي',
                privacyPolicy: 'سياسة الخصوصية',
                termsAndConditions: 'الشروط و الاحكام',
                register: 'تسجيل دخول',

                // Home
                whous: "من نحن",
                showmore: "رؤية المزيد",
                rays: 'الفحوصات و الاشعة',
                lab: "معمل",
                prescription: "روشتة",
                contactUs: "اتصل بنا",
                username: "اسم المستخدم",
                phonenum: "رقم الموبايل",

                // ContactUs
                downloadapp: "حمل التطبيق الان",

                // Profile
                personId: "الرقم التعريفي",
                editprofile: "تعديل الملف الشخصي",
                filesattached: "الملفات المرفقة",
                logout: "تسجيل الخروج",
                prescriptionhistory: "تاريخ الروشتة/الكشف",
                doctorname: "اسم الدكتور",
                medicinename: "اسم الدواء",
                medicinedate: "ميعاد تناول الدواء",
                diagnosis: "التشخيص",
                analyzesdate: "تاريخ التحاليل",
                labname: "اسم المعمل",
                raysdate: "تاريخ الاشعة",
                raystype: "نوع الاشعة",
                placename: "اسم المكان",
                deletecard: "هل تريد حذف ",
                fortifications: "تحصينات",
                choosecategory: "اختر من هذه الاقسام",
                internaldiseases: "امراض باطنة",
                respiratorysystem: "الجهاز التنفسي",
                earnose: "انف واذن وحنجرة",
                AddAnimal: 'اضافة حيوان',
                AddBtn: 'اضافة',
                upload: 'اضافة',
                PersonalInfo: " بيانات شخصية",
                medicineInfo: " بيانات طبية",
                email: "البريد الالكترونى",
                nationalID: "الرقم القومى",
                nationalIDImages: "صور الرقم القومى",
                medcalCardImages: "صور كارنيه التأمين الصحى ان وجد",
                male: "ذكر",
                female: "أنثى",
                changePassword: "تغيير كلمة المرور",
                resetPassword: " تغيير كلمة المرور",
                recentpassword: "كلمة المرور الحالية",
                medicines: "علاج وأدوية",
                chronicDiseases: "اكتب اسم المرض...",
                sensitivityType: "نوع الحساسية",
                operationName: "اسم العملية",
                doctorName: "اسم الدكتور",
                nomediciene: "لم يتم اضافة علاج وأدوية",
                PersonalInfo: " بيانات شخصية",
                medicineInfo: " بيانات طبية",
                email: "البريد الالكترونى",
                nationalID: "الرقم القومى",
                nationalIDImages: "صور الرقم القومى",
                medcalCardImages: "صور كارنيه التأمين الصحى ان وجد",
                male: "ذكر",
                female: "أنثى",
                changePassword: "تغيير كلمة المرور",
                resetPassword: " تغيير كلمة المرور",
                recentpassword: "كلمة المرور الحالية",
                medicines: "علاج وأدوية",
                // Auth
                forgetpassword: "نسيت كلمه المرور ؟",
                enterphonenum: "ادخل رقم الموبايل الذي سجلت به من قبل .. لأرسال الكود عليه",
                entercode: "ادخل الكود المرسل علي موبايلك",
                enterpassword: "ادخل كلمه المرور الجديده",
                newregister: "لا امتلك حساب؟ تسجيل جديد",
                password: "كلمة المرور",
                confpassword: "تاكيد كلمة المرور",

                //Lab
                Lab: 'معمل',
                AddPerson: 'أضافه شخص من الاسرة',

                // Children
                addchildren: "أضف بيانات شخص من الأولاد",
                addfamily: "أضف بيانات شخص من الاسرة",
                addanimal: "اضف بيانات الحيوان",
                AddChiled: 'أضافه شخص من الاولاد',
                Ray: 'الفحوصات و الاشعة',
                Fortifications: 'التحصينات',
                FortificationsName: 'اسم التحصين',
                FortificationsDate: 'تاريخ التحصين',
                FortificationsCardImg: 'صورة كارنية التخصينات',
                PrescriptionsCardImg: 'اضافة صورة الروشتة',
                profile: 'الملف الشخصي',
                alert: 'تنبية',
                medicineName: 'اسم الدواء',
                medicineTime: 'ميعاد تناول الدواء',
                doctorName: 'اسم الدكتور',
                other: 'أخري',
                Diagnosis: 'اكتب التشخيص',
                title: 'عنوان',
                DiagnosisSideTitle: 'التشخيص',
                // View Details
                Diagnosisname: "اسم التشخيص",
                Diagnosishistory: "تاريخ التحصين",
                birthcert: "صورة  الرقم القومى",
                helthinsu: "صورة كارنيه التامين الصحي",
                gender: "النوع",
                animaltype: "نوع الحيوان",
                bloodtype: "فصيلة الدم",
                age: "العمر",
                years: "سنوات",
                PhoneNum: 'رقم الموبايل',
                next: 'التالي',
                // Notification
                Notification: "الاشعارات",
        }
});

export default String;